import jsPDF, { jsPDFOptions } from 'jspdf';

export interface PdfGenerationOptions {
  pdfElement: HTMLElement;
  fileName: string;
  pdfOptions?: jsPDFOptions;
}

export interface PdfGenerationData {
  document: jsPDF;
  files: File[];
}

export const generatePdfFiles = async ({
  pdfElement,
  fileName,
  pdfOptions,
}: PdfGenerationOptions): Promise<PdfGenerationData> => {
  const document = new jsPDF({
    orientation: 'p',
    unit: 'px',
    format: 'a4',
    hotfixes: ['px_scaling'],
    precision: 10,
    ...pdfOptions,
  });

  await document.html(pdfElement);
  const fileBits = await document.output('arraybuffer');

  const files = [new File([fileBits], fileName, { type: 'application/pdf' })];

  return { document, files };
};
